import React from 'react';
import { useTranslation } from 'react-i18next';

import { getQuotaExhaustedNotice } from '../../../utils/quotaExhaustedNotice';

import type { ConversationMode } from '../../../constants/modes';

import './_chat-quota-exhausted-notice.scss';

/** The chat input points at it with aria-describedby, so the reason it is disabled is read with it. */
export const QUOTA_EXHAUSTED_NOTICE_ID = 'chat-quota-exhausted-notice-text';

type ChatQuotaExhaustedNoticeProps = {
  mode: ConversationMode;
};

/**
 * Tutor bubble telling the student they have no interactions left. UI only: it is never added to
 * the conversation, so it is not persisted and is not read back from the backend.
 */
function ChatQuotaExhaustedNotice({ mode }: ChatQuotaExhaustedNoticeProps): JSX.Element {
  const { t } = useTranslation(['chatbot']);
  const { body, title } = getQuotaExhaustedNotice(t, mode);

  return (
    <div className="chat-quota-exhausted-notice">
      <div className="chat-quota-exhausted-notice__avatar" />
      <p id={QUOTA_EXHAUSTED_NOTICE_ID} className="chat-quota-exhausted-notice__bubble">
        <strong className="chat-quota-exhausted-notice__title">{title}</strong> {body}
      </p>
    </div>
  );
}

export default ChatQuotaExhaustedNotice;
